import { loadStripe } from "@stripe/stripe-js";

// Stripe should be initialized once per app. Creating a new promise on every render
// can repeatedly load/initialize Stripe.js and spam the console with warnings.
const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined;

export const stripePromise = publishableKey ? loadStripe(publishableKey) : Promise.resolve(null);

